import { Routes } from '@angular/router';

import { AuthGuard } from '@core/guards';
import { WorkspaceStateService } from '@core/services';
import { AuthLayoutComponent } from '@ui/layouts/auth-layout/auth-layout.component';
import { WorkspaceLayoutComponent } from '@ui/layouts/workspace-layout/workspace-layout.component';

export const routes: Routes = [
    {
        path: '',
        component: AuthLayoutComponent, 
        loadChildren: () => import('@features/auth/routes'),
    },
    {
        path: '',
        canActivate: [AuthGuard],
        component: WorkspaceLayoutComponent,
        providers: [WorkspaceStateService],
        children: [
            {
                path: 'account', 
                loadChildren: () => import('@features/account/routes'),
            },
            {
                path: 'customers', 
                loadChildren: () => import('@features/customer/routes'),
            },
            {
                path: 'orders', 
                loadChildren: () => import('@features/order/routes'),
            },
            {
                path: 'products', 
                loadChildren: () => import('@features/product/routes'),
            },
            {
                path: 'alerts', 
                loadChildren: () => import('@features/alert/routes'),
            },
            {
                path: 'hijacks', 
                loadChildren: () => import('@features/hijack/routes'),
            },
            {
                path: 'thresholds', 
                loadChildren: () => import('@features/threshold/routes'),
            },
            {
                path: 'administrators', 
                loadChildren: () => import('@features/administrator/routes'),
            },
            {
                path: 'help', 
                loadChildren: () => import('@features/help/routes'),
            },
        ]
    },
];
